// Additional English strings. Merged with the base dictionary in LanguageContext.
export const en: Record<string, string> = {
  'common.close': 'Close',
  'common.close_window': 'Close dialog',
  'common.confirm': 'Confirm',
  'common.delete': 'Delete',
  'common.retry': 'Try again',
  'common.reset': 'Reset',
  'common.loading': 'Loading…',
  'common.empty': 'Nothing found',
  'common.error_generic': 'The request failed',
  'common.menu': 'Menu',
  'common.premium': 'Premium',
  'common.skip_to_content': 'Skip to content',
  'common.main_nav': 'Main navigation',
  'common.type_to_confirm': 'Type “{value}” to confirm',
  'dialog.discard_title': 'Close without saving?',
  'dialog.discard_text': 'Unsaved changes will be lost.',
  'dialog.discard': 'Discard changes',
  'dialog.keep_editing': 'Keep editing',
  'sidebar.anticheat': 'Download anti-cheat',
  'sidebar.anticheat_hint': 'Required to play matches',
  'header.close_notifications': 'Close notifications',
  'header.delete_notification': 'Delete notification',
  'header.account_menu': 'Account menu',
  'header.switch_language': 'Switch language',
  'stats.export_done': 'Match history page downloaded',
  'stats.refreshed': 'Data refreshed',
  'skins.add': 'Add skin',
  'skins.add_title': 'Add skin',
  'skins.configure': 'Customize skin',
  'skins.kind': 'Item type',
  'skins.kind.weapon': 'Weapons',
  'skins.kind.knife': 'Knives',
  'skins.kind.glove': 'Gloves',
  'skins.model': 'Model',
  'skins.all_models': 'All models',
  'skins.search_name': 'Search by name…',
  'skins.search_sticker': 'Search stickers…',
  'skins.search_charm': 'Search charms…',
  'skins.active_filters': 'Active filters',
  'skins.remove_filter': 'Remove filter “{value}”',
  'skins.catalog_error': 'Could not load the catalog',
  'skins.nothing_found': 'Nothing found',
  'skins.nothing_found_for': 'No items match “{value}”.',
  'skins.clear_search': 'Clear search',
  'skins.range': '{from}–{to} of {total}',
  'skins.side': 'Side',
  'skins.wear': 'Condition',
  'skins.wear.factory_new': 'Factory New',
  'skins.wear.minimal_wear': 'Minimal Wear',
  'skins.wear.field_tested': 'Field-Tested',
  'skins.wear.well_worn': 'Well-Worn',
  'skins.wear.battle_scarred': 'Battle-Scarred',
  'skins.decorations': 'Decorations',
  'skins.stickers': 'Stickers',
  'skins.charm': 'Charm',
  'skins.sticker': 'Sticker',
  'skins.slot': 'Slot {n}',
  'skins.slot_add': 'Add a sticker to slot {n}',
  'skins.slot_replace': 'Slot {n}: {name}. Replace',
  'skins.slot_remove': 'Remove sticker from slot {n}',
  'skins.charm_add': 'Add charm',
  'skins.charm_replace': 'Charm: {name}. Replace',
  'skins.charm_remove': 'Remove charm',
  'skins.pick_sticker': 'Sticker · slot {n}',
  'skins.pick_charm': 'Charm',
  'skins.back_to_catalog': 'Back to catalog',
  'skins.need_premium': 'Premium is required to save skins.',
  'skins.saving': 'Saving…',
  'skins.save_apply': 'Save changes',
  'skins.add_apply': 'Add to inventory',
  'skins.saved': 'Loadout saved',
  'skins.deleted': 'Item deleted',
  'skins.load_error': 'Could not load your inventory',
  'skins.empty_title': 'Build your first loadout',
  'skins.empty_text': 'Add a weapon, knife or gloves, choose a side and decorations — the loadout is applied in matches.',
  'skins.not_in_game': 'Not used in game',
  'skins.search_inventory': 'Search inventory',
  'skins.kind_all': 'All types',
  'skins.side_t_short': 'Terrorists',
  'skins.side_ct_short': 'Counter-Terrorists',
  'skins.side_required': 'Choose at least one side.',
  'skins.filter_all': 'All',
  'skins.filter_none': 'Not equipped',
  'skins.filter_label': 'Side',
  'skins.loadout_title': 'Loadout: {side}',
  'skins.loadout_knife': 'Knife',
  'skins.loadout_gloves': 'Gloves',
  'skins.loadout_weapons': 'Weapons',
  'skins.loadout_empty': 'Not set',
  'skins.loadout_weapons_count': '{n}',
  'skins.side_empty_title': 'Nothing selected for this side',
  'skins.side_empty_text': 'Open the "All" tab and press "Equip" on the item you want.',
  'skins.none_empty_title': 'All items are assigned',
  'skins.none_empty_text': 'Every item is equipped for at least one side.',
  'skins.delete': 'Remove from set',
  'skins.delete_title': 'Delete this item from your inventory?',
  'skins.delete_text': 'The item, its stickers and charm will disappear from your CS Hub set and its side will be freed. Steam items are not affected. You can add it again from the catalog.',
  'skins.rarity.consumer': 'Consumer Grade',
  'skins.rarity.industrial': 'Industrial Grade',
  'skins.rarity.milspec': 'Mil-Spec',
  'skins.rarity.restricted': 'Restricted',
  'skins.rarity.classified': 'Classified',
  'skins.rarity.covert': 'Covert',
  'skins.rarity.contraband': 'Contraband',
  'skins.rarity.special': 'Rare special item',
  'common.saved': 'Saved',
  'home.mode': '5×5 · Russia',
  'home.team': 'Team',
  'home.history': 'Match history',
  'home.all_stats': 'All statistics',
  'home.history_error': 'Could not load match history',
  'home.history_empty': 'No matches yet',
  'home.history_empty_text': 'The result of your first finished match will appear here',
  'home.map_none': 'No map selected',
  'home.show_more': 'Show more',
  'home.result.win': 'Win',
  'home.result.loss': 'Loss',
  'home.result.draw': 'Draw',
  'home.result.pending': 'In progress',
  'home.sync_error': 'Could not refresh the search. Reconnecting…',
  'home.search_players': 'Search players',
  'home.search_placeholder': 'Find a player by name…',
  'home.search_none': 'No players found.',
  'home.search_hint': 'Search covers all players. Add them as friends to invite them to your team.',
  'home.add_friend': 'Add friend',
  'home.add_friend_named': 'Add friend: {name}',
  'home.invite_team': 'Invite to team',
  'home.invite_named': 'Invite to team: {name}',
  'home.remove_friend': 'Remove friend',
  'home.remove_named': 'Remove friend: {name}',
  'home.need_steam': 'Link your Steam account to start playing.',
  'home.link_steam': 'Link Steam',
  'home.searching': 'Looking for opponents',
  'home.sec': 'sec',
  'home.sound_on': 'Turn sound on',
  'home.sound_off': 'Turn sound off',
  'home.cancelling': 'Cancelling search…',
  'home.cancel_search': 'Cancel search',
  'home.waiting_ready': 'Waiting for players to get ready',
  'home.ready_to_search': 'The team is ready — you can find a match.',
  'home.confirm_ready': 'Confirm that you are ready',
  'home.search_starting': 'Starting search…',
  'home.debug_mode': 'Debug mode (Dev): 10 s search, bots fill the rest',
  'home.find_match': 'Find match',
  'home.not_ready': 'Not ready',
  'home.im_ready': 'I am ready',
  'home.leader': 'Leader',
  'home.ready': 'Ready',
  'home.steam_needed': 'Steam required',
  'home.make_leader': 'Make leader',
  'home.make_leader_named': 'Make {name} the leader',
  'home.kick': 'Remove from team',
  'home.kick_named': 'Remove {name} from team',
  'home.invite_player': 'Invite a player',
  'home.leave': 'Leave team',
  'home.invitation': 'Invitation',
  'home.invitation_text': '{name} invites you to their team',
  'home.join': 'Join',
  'home.readiness': 'Ready to play',
  'home.steam_linked': 'Steam linked',
  'home.steam_not_linked': 'Steam not linked',
  'home.gameguard': 'GameGuard anti-cheat',
  'home.gameguard_hint': 'Required for matches. The site cannot verify the installation automatically.',
  'home.team_count': 'In team: {n} of 5',
  'home.friends': 'Friends',
  'home.friend_requests': 'Friend requests',
  'home.accept_friend': 'Accept',
  'home.accept_friend_named': 'Accept friend request: {name}',
  'home.decline': 'Decline',
  'home.decline_named': 'Decline request: {name}',
  'home.status.in_game': 'In game',
  'home.status.online': 'Online',
  'home.status.offline': 'Offline',
  'home.no_friends': 'No friends yet',
  'home.invite_hint': 'Choose a friend or find a player. To invite someone you found, add them as a friend first.',
  'home.no_friends_invite': 'No friends yet — find a player below and send a request.',
  'home.find_players': 'Find players',
  'home.invite': 'Invite',
  'home.remove_title': 'Remove from friends?',
  'home.remove_text': 'The player will disappear from your friends list. You can send a new request later.',
  'home.keep': 'Keep',
  'home.removed': 'Removed from friends',
  'steam.connecting': 'Connecting Steam',
  'steam.connecting_text': 'We are confirming your game account. This takes a few seconds.',
  'steam.checking': 'Checking account',
  'steam.retry_needed': 'Please try again',
  'steam.conflict.title': 'This Steam is already linked',
  'steam.conflict.text': 'This Steam account is already used by another CS Hub profile. Sign in to that profile or link a different Steam.',
  'steam.expired.title': 'Steam session expired',
  'steam.expired.text': 'The confirmation took too long. Please try again.',
  'steam.invalid.title': 'Steam did not confirm the sign-in',
  'steam.invalid.text': 'The Steam response could not be verified. Please sign in again.',
  'steam.unavailable.title': 'Steam is unavailable',
  'steam.unavailable.text': 'Steam is not responding right now. Try again in a few minutes.',
  'steam.failed.title': 'Could not connect Steam',
  'steam.failed.text': 'Something went wrong. Try again or contact support.',
  'steam.back_profile': 'Back to profile',
  'steam.back_login': 'Back to sign in',
  'steam.other_account': 'Use another Steam account',
  'steam.contact_support': 'Contact support',
  'stats.export_page': 'Export page',
  'stats.filter.only_draws': 'Draws only',
  'stats.scope': 'Filters and search apply to the metrics, charts and history. Period: {period}.',
  'stats.summary_error': 'Could not load the metrics',
  'stats.elo_summary': 'ELO changed from {from} to {to} over {n} points.',
  'stats.activity_summary': '{n} matches over {days} active days.',
  'stats.table.empty': 'No matches found',
  'stats.table.empty_for': 'Nothing matches “{value}”. Change the filters or clear the search.',
  'stats.open_match': 'Open match',
  'match.back_history': 'Back to match history',
  'match.load_error': 'Could not load the match',
  'match.to_home': 'Go home',
  'match.loading': 'Loading match…',
  'match.region': 'Russia',
  'match.score': 'Final score',
  'match.phase.voting': 'Map voting',
  'match.phase.starting': 'Server is starting',
  'match.phase.running': 'Connecting',
  'match.phase.finished': 'Finished',
  'match.phase.cancelled': 'Cancelled',
  'match.phase.error': 'Launch error',
  'match.turn': 'Turn: {team} · {sec} s',
  'match.vote_hint': 'Ban the map you do not want to play. You can change your vote until the turn ends.',
  'match.leave_cancel': 'Leave team and cancel match',
  'match.ban': 'Ban map',
  'match.server': 'Server',
  'match.password': 'Password',
  'match.no_password': 'no password',
  'match.copied': 'Copied',
  'match.copy_failed': 'Could not copy',
  'match.copy': 'Copy command',
  'match.connect': 'Connect',
  'match.preparing': 'The server is getting ready. Connection details will appear here.',
  'match.found': 'Match found',
  'match.prep.title': 'Starting your server',
  'match.prep.elapsed': 'Elapsed time',
  'match.prep.reserve': 'Reserving a game server',
  'match.prep.boot': 'Launching CS2',
  'match.prep.map': 'Loading {map}',
  'match.prep.plugin': 'Waiting for the server to confirm it is ready',
  'match.prep.hint': 'This usually takes 1–2 minutes. Keep this page open — connection details will appear here on their own.',
  'match.prep.kicker': 'Match map',
  'match.prep.short.reserve': 'Server',
  'match.prep.short.boot': 'Launch CS2',
  'match.prep.short.map': 'Map',
  'match.prep.short.plugin': 'Ready check',
  'match.report_server': 'Report the server',
  'match.report_player': 'Report player',
  'match.report_player_named': 'Report player {name}',
  'match.report': 'Report',
  'match.reason': 'Reason',
  'match.report_text': 'What happened',
  'match.report_placeholder': 'Describe the problem',
  'match.reason.player.cheating': 'Cheating',
  'match.reason.player.abuse': 'Abuse',
  'match.reason.player.griefing': 'Griefing or AFK',
  'match.reason.player.other': 'Other',
  'match.reason.server.lag': 'Lag or drops',
  'match.reason.server.connection': 'Cannot connect',
  'match.reason.server.other': 'Other',
  'match.report_sent': 'Report sent',
  'match.sending': 'Sending…',
  'match.send': 'Send',
  'match.your_team': 'your team',
  'match.you': 'you',
  'match.player': 'Player',
  'match.open_profile': 'Open profile',
  'match.open_profile_named': 'Open profile: {name}',
  'match.request_sent': 'Request sent',
  'match.new': 'New match',
  'profile.tabs.settings': 'Settings',
  'profile.avatar_failed': 'Could not save the avatar',
  'profile.background_updated': 'Profile background updated',
  'profile.background_failed': 'Could not save the background',
  'profile.image_rejected': 'This file cannot be used: choose a JPG, PNG or GIF up to 3 MB.',
  'profile.image_hint': 'JPG, PNG or GIF, up to 3 MB',
  'profile.no_changes': 'There are no changes to save',
  'profile.username_short': 'The name must have at least 2 characters',
  'profile.save_failed': 'Could not save the profile',
  'pp.now_friends': 'You are friends now',
  'pp.request_sent': 'Request sent',
  'pp.back': 'Back',
  'pp.not_found': 'Player not found',
  'pp.avatar_of': 'Avatar of {name}',
  'pp.sending': 'Sending…',
  'pp.already_friends': 'Already friends',
  'pp.accept': 'Accept request',
  'pp.stats': 'Statistics',
  'clans.my_clan_error': 'Could not determine your clan.',
  'clans.tab.overview': 'All clans',
  'clans.tab.mine': 'My clan',
  'clans.tab.invitations': 'Invitations',
  'clans.search': 'Search clans…',
  'clans.sort_by': 'Sort by',
  'clans.sort.name': 'Name',
  'clans.sort.members': 'Members',
  'clans.sort.winRate': 'Win rate, %',
  'clans.order.asc': 'Ascending',
  'clans.order.desc': 'Descending',
  'clans.results': 'Clans: {n}',
  'clans.already_member': 'You are already a member of “{name}”',
  'clans.confirm.kick_title': 'Remove {name}?',
  'clans.confirm.kick_text': 'The player will lose access to the clan and can apply again.',
  'clans.confirm.kick': 'Remove',
  'clans.confirm.disband_title': 'Disband clan “{name}”?',
  'clans.confirm.disband_text': 'The clan and its roster will be deleted. This cannot be undone.',
  'clans.confirm.disband': 'Disband clan',
  'clans.confirm.leave_title': 'Leave clan “{name}”?',
  'clans.confirm.leave_text': 'You will no longer be a member of this clan.',
  'clans.confirm.leave': 'Leave clan',
  'premium.already_paid': 'This order is already paid',
  'premium.status.succeeded': 'Payment confirmed. Premium is active.',
  'premium.status.canceled': 'Payment cancelled. You can choose a term and try again.',
  'premium.status.pending': 'Waiting for payment confirmation…',
  'premium.status.error': 'Could not get the payment status.',
  'premium.renew': 'Renewal',
  'premium.term': 'Choose a term',
  'premium.active': 'Premium is active',
  'premium.active_until': 'Active until {date}',
  'premium.renew_hint': 'Renewal is added to your current term.',
  'premium.months': '{n} mo.',
  'premium.have_promo': 'I have a promo code',
  'premium.promo': 'Promo code',
  'premium.promo_placeholder': 'If you have one',
  'premium.promo_note': 'The discount appears in the total only after the code is checked.',
  'premium.total': 'To pay for {n} mo.',
  'premium.total_before_promo': 'To pay for {n} mo., promo code not applied',
  'premium.preparing': 'Preparing payment…',
  'premium.pay': 'Go to payment',
  'premium.renew_action': 'Renew Premium',
  'premium.need_email': 'An email is required for the receipt.',
  'premium.add_email': 'Add it in profile settings',
  'premium.pay_error': 'Could not start the payment',
  'premium.pay_error_next': 'Try again later or write to us:',
  'premium.secure': 'Payment via YooKassa. The subscription does not renew automatically.',
  'premium.use_title': 'Your skin loadout',
  'premium.use_text': 'Premium is active — customize weapons, knives and gloves for each side.',
  'premium.open_inventory': 'Open inventory',
  'premium.headline': 'Your own skins in every match',
  'premium.month': 'month',
  'premium.example': 'Loadout example',
  'premium.example_t': 'Attack set',
  'premium.example_ct': 'Defense set',
  'premium.f1': 'Weapons, knives and gloves',
  'premium.f2': 'Stickers and charms',
  'premium.f3': 'Different loadouts for T and CT',
  'premium.matches_free': 'Matches are free to play. Premium is only needed for your own skins.',
  'support.lead': 'Describe the problem — we receive the request together with your account.',
  'support.err.category': 'Choose a category',
  'support.err.subject': 'The subject needs at least 3 characters',
  'support.err.body': 'Please describe the problem in more detail — at least 10 characters',
  'support.sent': 'Request sent',
  'support.ticket': 'Request number',
  'support.after': 'Keep the number if you want to refer to this request.',
  'support.another': 'New request',
  'support.category': 'Category',
  'support.category_pick': 'Choose a category',
  'support.cat.account': 'Account and Steam',
  'support.cat.match': 'Matches and server',
  'support.cat.skins': 'Skins',
  'support.cat.premium': 'Premium and payment',
  'support.cat.tech': 'Technical problem',
  'support.cat.other': 'Other',
  'support.subject': 'Subject',
  'support.subject_placeholder': 'For example, Steam will not link',
  'support.body': 'What happened?',
  'support.body_placeholder': 'Describe the problem and the steps that led to it.',
  'support.ctx.steam': 'Steam connection',
  'support.ctx.premium': 'Premium and payment',
  'support.ctx.match': 'Match',
  'support.attach_context': 'Include context: {name}',
  'support.no_secrets': 'Do not send passwords, sign-in codes or payment details.',
  'support.send': 'Send request',
  'auth.step': 'Step {n} of 2',
  'auth.step1': 'Enter your email',
  'auth.step2': 'Confirm your email and set a password',
  'auth.err.email': 'Enter a valid email',
  'auth.err.username': 'Enter a player name',
  'auth.err.code': 'Enter the 6 digits from the email',
  'auth.err.password': 'Enter a password',
  'auth.err.password_long': 'The password must not exceed 72 characters',
  'auth.password_saved': 'Password saved',
  'auth.register.title': 'Create account',
  'auth.reset.title': 'Reset password',
  'auth.register.lead': 'Start with your email or sign in with Steam.',
  'auth.reset.lead': 'We will send a code to your email to set a new password.',
  'auth.username': 'Player name',
  'auth.username_placeholder': 'How others will see you in game',
  'auth.get_code': 'Get code',
  'auth.sending': 'Sending…',
  'auth.code_sent_to': 'Code sent to {email}.',
  'auth.change_email': 'Change email',
  'auth.code': 'Code from the email',
  'auth.resend': 'Send again',
  'auth.resend_in': 'Resend in {n}s',
  'auth.code_hint': 'Check your inbox and spam folder. The code is valid for 24 hours.',
  'auth.password': 'Password',
  'auth.new_password': 'New password',
  'auth.password_placeholder': 'Choose a password',
  'auth.hide_password': 'Hide password',
  'auth.show_password': 'Show password',
  'auth.password_rules': 'Up to 72 characters. We recommend 8+ characters with letters and digits.',
  'auth.wait': 'Please wait…',
  'auth.save_password': 'Save password',
  'auth.or_steam': 'or with your game account',
  'auth.continue_steam': 'Continue with Steam',
  'auth.have_account': 'Already have an account?',
  'auth.remembered': 'Remembered your password?',
  'auth.sign_in': 'Sign in',
  'auth.terms_prefix': 'By creating an account you accept the',
  'auth.terms': 'terms of service',
  'auth.and': 'and',
  'auth.privacy': 'privacy policy',
  'auth.login.title': 'Sign in',
  'auth.login.lead': 'Sign in with your email or through Steam.',
  'auth.password_enter': 'Enter your password',
  'auth.forgot': 'Forgot your password?',
  'auth.signing_in': 'Signing in…',
  'auth.or': 'or',
  'auth.login.steam': 'Sign in with Steam',
  'auth.no_account': 'No account yet?',
  'legal.footer_label': 'Documents and contacts',
  'legal.terms': 'User Agreement',
  'legal.privacy': 'Privacy Policy',
  'legal.consent': 'Personal data consent',
  'legal.cookie': 'Cookie Policy',
  'legal.doc_new_tab': 'opens in a new tab',
  'auth.agree_terms_prefix': 'I accept the',
  'auth.agree_terms_and': 'and have read the',
  'auth.agree_pd_prefix': 'I give',
  'auth.agree_pd_suffix': 'to the processing of my personal data',
  'auth.err.consent_terms': 'Confirm that you accept the agreement and have read the policy',
  'auth.err.consent_pd': 'Confirm your consent to personal data processing',
  'auth.err.consent_required': 'To register you must accept the agreement and consent to personal data processing',
  'steam.consent.title': 'Consent required to sign up',
  'steam.consent.text': 'This Steam account is not registered yet. Tick the consents on the sign-up page and sign in with Steam again.',
  'legal.to_register': 'Go to sign up',
  'home.level': 'Level {n}',
  'home.to_level': '{elo} ELO to level {n}',
  'home.max_level': 'Max level',
  'home.elo': 'ELO',
  'home.mode_label': 'Mode',
  'home.team_size': 'Squad',
  'home.you': 'You',
  'home.invite_slot_hint': 'Open slot',
  'home.invite_sent': 'Invitation sent',
  'home.invited': 'Invited',
  'home.solo_ok': 'You can play solo',
  'home.reason.steam': 'Link Steam to take part in matches',
  'home.reason.member_steam': '{name} has not linked Steam.',
  'home.reason.not_ready': 'Waiting for players to get ready: {names}',
  'home.reason.sync': 'Refreshing state…',
  'home.reason.leader_only': 'The party leader starts the search',
  'home.ready_all': 'Ready to search',
  'home.searching_hint': 'Keep this page open to be taken to the match right away',
  'home.searching_member': 'Your leader is finding a match for the team',
  'home.check.steam': 'Steam',
  'home.check.gameguard': 'GameGuard',
  'home.check.team': 'Party',
  'home.check.linked': 'linked',
  'home.check.link': 'Link',
  'home.check.download': 'Download',
  'home.check.unverifiable': 'Manual check',
  'home.check.fix': 'Fix',
  'home.friends_online': '{n} online',
  'home.searching_players': 'Searching players…',
  'home.search_clear': 'Clear search',
  'home.friend_pending': 'Request sent',
  'home.friend_already': 'Already friends',
  'home.friends_empty_title': 'No one here yet',
  'home.friends_empty_text': 'Find teammates by name and add them as friends — they will show up here and can join your party.',
  'home.friends_empty_cta': 'Find a player',
  'home.friends_load_error': 'Could not load friends',
  'home.view_profile': 'Profile',
  'home.invitation_from': 'Party invitation',
  'home.friends_hint_short': 'Only friends can be invited',
  'nav.help': 'Help and downloads',
  'nav.subscription': 'Premium',
  'header.subscription': 'Premium',
  'header.settings': 'Settings',
  'header.language': 'Language',
  'lang.ru': 'Русский',
  'lang.en': 'English',
  'common.open_menu': 'Open menu',
  'home.unready': 'Unready',
  'home.open_slot': 'Open slot',
  'home.invite_short': 'Invite',
  'home.gameguard_note': 'GameGuard is required to play; this site cannot check whether it is installed',
  'home.gameguard_download': 'Download GameGuard',
  'home.more_reasons': '{n} more',
  'home.reasons_hide': 'Hide',
  'home.kick_title': 'Remove {name} from the party?',
  'home.kick_text': 'The player will leave the party and can return only by a new invitation.',
  'home.member_actions': 'Actions: {name}',
  'home.recent': 'Recent matches',
  'home.all_matches': 'All matches',
  'home.map_pending': 'Map is being chosen',
  'home.state.waiting': 'Map veto',
  'home.state.cancelled': 'Cancelled',
  'home.level_short': 'Lv {n}',
  'home.friends_open': 'Friends',
  'home.friends_sheet': 'Friends and invitations',
  'home.loading_team': 'Loading party',
  'home.party_full': 'The party has no open slots',
  'home.in_team': 'In party',
  'home.search_players_label': 'Find a player by name',
  'home.invite_slots': 'Open slots: {n}',
  'home.friend_incoming': 'Request received',
  'home.friend_in_party': 'In party',
  'home.invite_full': 'The party has no open slots',
  'home.invite_searching': 'Match search in progress',
  'home.online_count': '{n} online',
  'home.row_actions': 'Actions: {name}',
  'home.accept_short': 'Accept',
  'home.decline_short': 'Decline',
  'home.friends_in_friends': 'Friends',
  'home.remove_title_named': 'Remove {name} from friends?',
  'stats.no_data': 'No data',
  'stats.kpi_matches_hint': 'Finished matches',
  'stats.current_elo': 'Current ELO',
  'stats.current_elo_hint': 'Not affected by filters',
  'stats.winrate_hint': 'Finished matches only',
  'stats.kd_hint': 'Kills per death',
  'stats.filters_btn': 'Filters',
  'stats.elo_note': 'Calculated from finished matches, draws excluded',
  'stats.single_point': 'One observation: {elo} ELO, {date}',
  'stats.outcomes': 'Outcomes',
  'stats.maps_title': 'Maps',
  'stats.maps_hint': 'Finished matches by map',
  'stats.activity_title': 'Activity by day',
  'stats.activity_hint': 'Matches per day, days with games only',
  'stats.matches_unit': 'matches',
  'stats.empty_title': 'No matches yet',
  'stats.empty_text': 'The result of your first finished match will appear here. Your rating is {elo} ELO.',
  'stats.empty_cta': 'Go play',
  'stats.remove_filter': 'Remove filter: {name}',
  'stats.reset_filters': 'Reset filters',
  'stats.table.search_placeholder': 'Map or mode',
  'stats.history_scope': 'History for the selected conditions',
  'stats.filtered_empty': 'Nothing found for these conditions',
  'stats.updating': 'Updating…',
  'stats.small_sample': 'small sample',
  'stats.dur_unknown': 'duration unknown',
  'stats.wins_short': 'Wins',
  'stats.losses_short': 'Losses',
  'stats.draws_short': 'Draws',
  'stats.outcome_of': 'of {n} finished',
  'stats.period_label': 'Period',
  'stats.elo_chart_title': 'ELO trend',
  'stats.legend_elo': 'ELO',
  'stats.show_results': 'Show {n}',
  'skins.more_actions': 'More actions: {name}',
  'skins.delete_title_named': 'Remove {name} from your CS Hub set?',
  'skins.set_note': 'Your arsenal for CS Hub matches: items, sides, stickers and charms.',
  'skins.no_results_title': 'Nothing matches these filters',
  'skins.no_results_text': 'Change the search or reset the filters. Your items and loadout are not affected.',
  'skins.kind_empty_title': 'Your inventory has no {kind} yet.',
  'skins.kind_empty_text': 'Add an item of this type from the catalog.',
  'skins.premium_title': 'Skins are available with Premium',
  'skins.premium_text': 'Premium unlocks your own set for T and CT. You can play matches without it.',
  'skins.premium_cta': 'Go to Premium',
  'skins.kind_plural.weapon': 'weapons',
  'skins.kind_plural.knife': 'knives',
  'skins.kind_plural.glove': 'gloves',
  'skins.configure_named': 'Configure: {name}',
  'skins.configure_short': 'Configure',
  'profile.settings_btn': 'Profile settings',
  'profile.settings_title': 'Profile settings',
  'profile.back': 'Back to profile',
  'profile.nav': 'Profile sections',
  'profile.nav_overview': 'Overview',
  'profile.nav_settings': 'Settings',
  'profile.stats.draws': 'Draws',
  'profile.newbie_title': 'Statistics will appear after your first finished match',
  'profile.newbie_text': 'Your starting rating is already set. Play a match and the results will show up here.',
  'profile.to_game': 'Go play',
  'profile.indicators': 'Performance',
  'profile.favorite_map': 'Best-performing map',
  'profile.no_data': 'No data',
  'profile.recent': 'Recent matches',
  'profile.full_stats': 'Full statistics',
  'profile.appearance': 'Appearance',
  'profile.account': 'Account',
  'profile.username_label': 'Username',
  'profile.avatar_label': 'Avatar',
  'profile.background_label': 'Profile background',
  'profile.replace': 'Replace',
  'profile.choose': 'Choose file',
  'profile.drop_hint': 'or drop a file here',
  'profile.file_hint': 'JPG, PNG or GIF, up to 3 MB',
  'profile.err_type': 'Only JPG, PNG and GIF are supported',
  'profile.err_size': 'The file is larger than 3 MB',
  'profile.err_read': 'Could not read the file',
  'profile.saved': 'Changes saved',
  'profile.discard': 'Cancel',
  'profile.save': 'Save',
  'profile.unsaved': 'You have unsaved changes',
  'profile.no_background': 'No background set',
  'profile.preview': 'Preview',
  'profile.leave_warn': 'You have unsaved changes. Leave the page?',
  'account.email': 'Email',
  'account.email_none': 'No email set',
  'account.steam': 'Steam',
  'account.steam_linked': 'Linked',
  'account.steam_link': 'Link Steam',
  'account.clan_tag': 'Show clan tag in game',
  'account.clan_tag_hint': 'Only affects how your name is shown in matches',
  'account.change_email': 'Change email',
  'account.change_password': 'Change password',
  'account.set_password': 'Set password',
  'account.new_email': 'New email',
  'account.new_password': 'New password',
  'account.code': 'Confirmation code',
  'account.get_code': 'Get code',
  'account.resend_code': 'Send code again',
  'account.code_sent': 'Code sent to {email}. It is valid for 24 hours.',
  'account.confirm': 'Confirm',
  'account.show_password': 'Show password',
  'account.hide_password': 'Hide password',
  'account.saved_email': 'Email changed',
  'account.saved_password': 'Password changed',
  'account.setting_saved': 'Setting saved',
  'account.err_email': 'Enter a valid email',
  'account.err_password': 'Enter a new password',
  'account.err_code': 'Enter the code from the email',
  'account.sent_new': 'The code will go to the new address.',
  'account.sent_account': 'The code will go to your account email.',
  'account.close': 'Close',
  'pp.not_found_text': 'There is no profile with this ID. The link may be outdated.',
  'pp.forbidden': 'Profile unavailable',
  'pp.forbidden_text': 'You do not have access to this profile.',
  'pp.load_failed': 'Could not load the profile',
  'pp.load_failed_text': 'This is a temporary failure, not a missing player. Please try again.',
  'pp.no_stats': 'There are no public statistics yet.',
  'cl.members_n': '{n} of {max}',
  'cl.members_label': 'members',
  'cl.winrate': 'win rate',
  'cl.avg_elo': 'avg ELO {n}',
  'cl.private': 'Closed',
  'cl.invite_only': 'Invite only',
  'cl.by_request': 'Join by request',
  'cl.free_join': 'Open to join',
  'cl.requirements': 'Requirements',
  'cl.req_level': 'level {n}+',
  'cl.req_elo': 'ELO {n}+',
  'cl.req_winrate': 'win rate {n}%+',
  'cl.req_games': '{n}+ games',
  'cl.req_none': 'No requirements',
  'cl.details': 'Details',
  'cl.join': 'Join',
  'cl.apply': 'Request to join',
  'cl.applied': 'Request sent',
  'cl.full': 'No open slots',
  'cl.your_clan': 'Your clan',
  'cl.in_other': 'You are already in a clan',
  'cl.empty_find': 'No clans found',
  'cl.empty_find_text': 'Change the query or reset the search.',
  'cl.empty_dir': 'No clans yet',
  'cl.empty_dir_text': 'Create the first clan so other players can join it.',
  'cl.role_leader': 'Leader',
  'cl.role_member': 'Member',
  'cl.you': 'You',
  'cl.created': 'Created {date}',
  'cl.led_by': 'Leader: {name}',
  'cl.edit': 'Edit',
  'cl.leave': 'Leave clan',
  'cl.disband': 'Disband clan',
  'cl.invite': 'Invite',
  'cl.invite_title': 'Invite a player',
  'cl.invite_placeholder': 'Player name or email',
  'cl.requests': 'Join requests',
  'cl.requests_none': 'No new requests',
  'cl.accept': 'Accept',
  'cl.decline': 'Decline',
  'cl.members': 'Members',
  'cl.kick': 'Remove',
  'cl.stat_members': 'Members',
  'cl.stat_winrate': 'Win rate',
  'cl.stat_matches': 'Matches per member (avg)',
  'cl.stat_elo': 'Average ELO',
  'cl.rules_join': 'Join rules',
  'cl.links': 'Links',
  'cl.rules': 'Clan rules',
  'cl.no_clan': 'You are not in a clan',
  'cl.no_clan_text': 'Find a clan you like or create your own.',
  'cl.find': 'Find a clan',
  'cl.create': 'Create clan',
  'cl.inv_none': 'No invitations',
  'cl.inv_none_text': 'When a clan invites you, the invitation will appear here.',
  'cl.inv_from': '{name} invites you',
  'cl.inv_expires': 'Valid until {date}',
  'cl.inv_expired': 'Expired',
  'cl.to_overview': 'Browse clans',
  'cl.leader': 'Leader',
  'cl.type': 'Type',
  'cl.type_public': 'Open',
  'cl.type_private': 'Closed',
  'cl.max_members': 'Member limit',
  'cl.approval_yes': 'The leader approves requests',
  'cl.approval_no': 'Joining needs no approval',
  'cl.members_invite_yes': 'Members can invite',
  'cl.members_invite_no': 'Only the leader invites',
  'cl.close': 'Close',
  'cl.member_actions': 'Actions: {name}',
  'cl.level_short': 'Lv {n}',
  'cl.open_link_discord': 'Discord',
  'cl.open_link_site': 'Website',
  'cl.search_clear': 'Reset search',
  'cl.no_desc': 'No description',
  'cl.invite_sent': 'Invitation sent',
  'premium.sub': 'Your own skin sets for T and CT. You can play matches without Premium.',
  'premium.per_month': '{amount} per month',
  'premium.promo_check': 'Check',
  'premium.promo_checking': 'Checking…',
  'premium.promo_valid': '{n}% off',
  'premium.promo_invalid': 'Promo code not found or inactive',
  'premium.unavailable': 'Payments are temporarily unavailable',
  'premium.unavailable_text': 'Your term and promo code are kept. Try again later or contact support.',
  'premium.config_error': 'Could not load prices',
  'premium.adds_to_current': 'The new term is added to your current end date.',
  'premium.new_until': 'After payment Premium will be active until {date}',
  'premium.retry': 'Retry',
  'premium.base_price': 'Before discount',
  'support.copy': 'Copy',
  'support.copied': 'Copied',
  'support.new': 'New request',
  'support.memo_title': 'What to include',
  'support.memo_1': 'What you were doing and what you expected',
  'support.memo_2': 'What actually happened',
  'support.memo_3': 'The match number or item name, if relevant',
  'support.send_failed': 'Could not send the request. Your text is kept — please try again.',
  'support.counter': '{n} of 2000',
  'match.title_veto': 'Map veto',
  'match.turn_of': '{team} to ban',
  'match.time_left': 'Time left',
  'match.your_vote': 'Your vote',
  'match.votes_n': 'Votes: {n}',
  'match.wait_turn': 'The other team is choosing',
  'match.finished': 'Match finished',
  'match.cancelled': 'Match cancelled',
  'match.reason_label': 'Reason: {text}',
  'match.start_failed': 'Could not start the match',
  'match.start_failed_text': 'The match server is unavailable right now. Go back and start a new search.',
  'match.not_found': 'Match not found',
  'match.not_found_text': 'There is no such match; the link may be outdated.',
  'match.leave_title': 'Leave and cancel the match?',
  'match.leave_text': 'You will leave the party and the match will be cancelled for everyone.',
  'match.leave_confirm': 'Leave and cancel',
  'match.connect_title': 'Connection',
  'match.sync_lost': 'No connection to the server. Showing the last received data.',
  'match.stats_head': 'K / D / A',
  'match.stats_hint': 'Kills / deaths / assists',
  'match.members_n': '{n} players',
  'match.player_actions': 'Actions: {name}',
  'match.map_unknown': 'Map is being chosen',
  'match.connect_hint': 'Visible only to match participants.',
  'match.retry': 'Retry',
  'land.eyebrow': 'Counter-Strike 2 · 5v5',
  'land.h1': 'Your next round',
  'land.sub': 'Competitive 5v5 matches with a team or solo, ELO rating and your own skin set.',
  'land.cta': 'Start playing',
  'land.cta_in': 'Go to the game',
  'land.login': 'Sign in',
  'land.register': 'Create account',
  'land.download': 'Download GameGuard',
  'land.b1_title': 'A match in minutes',
  'land.b1_text': 'Form a party of up to five or play solo. The leader starts the search, members confirm readiness, then teams pick a map and connect to the server.',
  'land.b1_li1': 'Invite friends straight from the lobby',
  'land.b1_li2': 'Map veto by vote before the match',
  'land.b1_li3': 'Connection details only for match participants',
  'land.b2_title': 'Rating and full history',
  'land.b2_text': 'ELO and level, K/D, win rate, rating trend by match and a full history with page export.',
  'land.b2_li1': 'Filters by map, period and result',
  'land.b2_li2': 'Player profile and friends in one place',
  'land.b2_li3': 'Clans with requests and invitations',
  'land.b3_title': 'Your own skin set',
  'land.b3_text': 'Premium unlocks your own sets for T and CT: weapons, knives, gloves, stickers and charms. Matches are free to play.',
  'land.steps_title': 'How to start',
  'land.step1': 'Create an account or sign in with Steam',
  'land.step2': 'Link Steam',
  'land.step3': 'Install GameGuard — it is required to play matches',
  'land.step4': 'Form a party or play solo and start the search',
  'land.maps_title': 'Maps',
  'land.maps_text': 'Competitive CS2 maps. The map of a specific match is chosen before the game.',
  'land.final_title': 'Ready for a match?',
  'land.final_text': 'Create an account and find your first game.',
  'land.terms': 'Terms',
  'land.privacy': 'Privacy',
  'land.motion_pause': 'Pause animation',
  'land.motion_play': 'Play animation',
  'auth.back_home': 'Back to home',
  'auth.story_1': 'Your team.',
  'auth.story_2': 'Your round.',
  'auth.err.invalid_credentials': 'Wrong email or password',
  'auth.err.network': 'Could not reach the server. Please try again.',
  'auth.err.email_taken': 'An account with this email already exists',
  'auth.err.too_many': 'Too many attempts. Wait a moment and try again.',
  'land.b2_f1': 'Level and rating',
  'land.b2_f2': 'Kills per death',
  'land.b2_f3': 'Finished matches only',
  'land.b2_f4': 'Map, score and roster',
  'adm.platform': 'Back to platform',
  'adm.nav': 'Administration',
  'adm.overview': 'Overview',
  'adm.users': 'Users',
  'adm.maps': 'Maps',
  'adm.subscriptions': 'Subscriptions',
  'adm.finance': 'Finance',
  'adm.moderation': 'Moderation',
  'adm.analytics': 'Analytics',
  'adm.settings': 'Settings',
  'adm.support': 'Support requests',
  'adm.refresh': 'Refresh',
  'adm.export_page': 'Export page',
  'adm.details': 'Details',
  'adm.close': 'Close',
  'adm.retry': 'Retry',
  'adm.loading': 'Loading…',
  'adm.load_error': 'Could not load data',
  'adm.total': 'Total: {n}',
  'adm.search_users': 'Search by name or email',
  'adm.col_user': 'User',
  'adm.col_profile': 'Game profile',
  'adm.col_sub': 'Subscription',
  'adm.col_role': 'Role',
  'adm.col_reg': 'Registered',
  'adm.premium_on': 'Premium active',
  'adm.premium_off': 'None',
  'adm.role_admin': 'Administrator',
  'adm.role_user': 'Player',
  'adm.no_email': 'No email',
  'adm.no_users': 'No users found',
  'adm.copy_id': 'Copy ID',
  'adm.copied': 'ID copied',
  'adm.user_note': 'View only. Editing accounts from the panel is unavailable: the server has no such operations.',
  'adm.level': 'Level {n}',
  'adm.id': 'ID',
  'adm.maps_add': 'Add map',
  'adm.maps_edit': 'Edit',
  'adm.maps_activate': 'Activate',
  'adm.maps_delete': 'Delete',
  'adm.maps_empty': 'No maps yet',
  'adm.maps_search': 'Search maps',
  'adm.map_name': 'Identifier (de_mirage)',
  'adm.map_display': 'Display name',
  'adm.map_desc': 'Description',
  'adm.map_image': 'Image URL',
  'adm.map_workshop': 'Workshop ID',
  'adm.map_category': 'Category',
  'adm.map_status': 'Status',
  'adm.map_min': 'Minimum players',
  'adm.map_max': 'Maximum players',
  'adm.map_official': 'Official map',
  'adm.map_saved': 'Map saved',
  'adm.map_deleted': 'Map deleted',
  'adm.map_required': 'Enter an identifier and a name',
  'adm.map_delete_title': 'Delete map {name}?',
  'adm.map_delete_text': 'The map will be removed from the database. If it is in use, the server will refuse.',
  'adm.cat.main': 'Main',
  'adm.cat.reserve': 'Reserve',
  'adm.cat.premium': 'Premium',
  'adm.cat.custom': 'Custom',
  'adm.st.active': 'Active',
  'adm.st.inactive': 'Disabled',
  'adm.st.pending': 'Pending',
  'adm.mod_filter': 'Status',
  'adm.mod_all': 'All',
  'adm.mod_empty': 'No complaints',
  'adm.mod_from': 'Author: {id}',
  'adm.mod_open': 'New',
  'adm.mod_progress': 'In progress',
  'adm.mod_closed': 'Closed',
  'adm.mod_to_progress': 'Take into work',
  'adm.mod_close': 'Close complaint',
  'adm.mod_updated': 'Status updated',
  'adm.mod_reason': 'Reason',
  'adm.mod_note': 'A complaint is a user message, not a finding of a violation.',
  'adm.sup_empty': 'No requests',
  'adm.sup_search': 'Search by subject, author and text',
  'adm.sup_scope': 'The latest requests are shown (up to 100).',
  'adm.sup_number': 'No. {n}',
  'adm.sup_pick': 'Select a request',
  'adm.sup_back': 'Back to list',
  'adm.ov_users': 'Users',
  'adm.ov_maps': 'Maps in database',
  'adm.ov_complaints': 'New complaints',
  'adm.ov_tickets': 'Requests',
  'adm.ov_scope_tickets': 'in the latest sample (up to 100)',
  'adm.ov_recent': 'Latest requests',
  'adm.ov_recent_complaints': 'Latest complaints',
  'adm.ov_open': 'Open',
  'adm.na_title': 'This section is not connected to data',
  'adm.na_text': 'The server has no API for this section, so no values are shown: demo figures must not pass as real ones.',
  'adm.na_subscriptions': 'The server does not support a subscription list or operations yet. Premium status is visible under Users.',
  'adm.na_finance': 'Premium payments are created in the payment system, but there is no admin API to view them.',
  'adm.na_analytics': 'There is no aggregated analytics on the server.',
  'adm.na_settings': 'Platform settings are not stored on the server; parameters come from environment configuration.',
  'match.team_named': 'Team {name}',
  'sys.not_found': 'Page not found',
  'sys.not_found_text': 'There is no such address. The link may be outdated or contain a typo.',
  'sys.to_start': 'To the home page',
  'sys.forbidden': 'Access denied',
  'sys.forbidden_text': 'This section is available to platform administrators only.',
  'sys.temporary': 'The service is temporarily unavailable. Please try again.',
  'cl.dir_error': 'Could not load the clan list',
  'premium.promo_check_failed': 'Could not check the promo code. Please try again.',
  'skins.reset_all': 'Reset all',
  'skins.installed': 'Selected',
  'skins.editor_title': 'Item settings',
  'skins.found_of': 'Found {n} of {total}',
  'skins.view_label': 'View',
  'skins.view_t': 'For T',
  'skins.view_ct': 'For CT',
  'skins.status_t': 'Equipped for T',
  'skins.status_ct': 'Equipped for CT',
  'skins.status_none': 'Not equipped',
  'skins.equip': 'Equip',
  'skins.equip_menu': 'Loadout',
  'skins.equip_menu_title': 'Loadout: {name}',
  'skins.equip_now': 'Now for {side}: {name}',
  'skins.equip_none_now': 'Nothing equipped for {side} yet',
  'skins.equip_action': 'Action: equip {name}',
  'skins.equip_for': 'Equip for {side}',
  'skins.unequip_for': 'Unequip for {side}',
  'skins.equip_this': 'Equipped for {side}',
  'skins.equip_incompatible': 'Not available for {side}',
  'skins.equipped_toast': '{name} equipped for {side}',
  'skins.unequipped_toast': '{name} unequipped for {side}',
  'skins.equip_error': 'Could not save. Your previous loadout is unchanged.',
  'skins.equip_saving': 'Saving…',
  'skins.wear_unset': 'Not set',
  'skins.pane_params': 'Settings',
  'skins.pane_deco': 'Decorations',
  'skins.slot_current': 'Installed: {name}',
  'skins.slot_empty': 'Slot is empty',
  'skins.slot_pick_hint': 'Pick a decoration from the catalog below.',
  'skins.slot_replace_hint': 'To replace it, pick another decoration below.',
  'skins.slot_clear': 'Remove from slot',
  'skins.slot_active': 'Active',
  'skins.equip_draft_note': 'Changes after you save',
  'skins.side_t_name': 'Terrorists · T',
  'skins.side_ct_name': 'Counter-Terrorists · CT',
  'skins.empty_deco': 'No decorations',
  'skins.draft_replaces': 'Now for {side}: {name}. Will be replaced after you save.',
  'skins.equipped_replaced_toast': '{name} equipped for {side}. {other} stays in your inventory',
  'nav.referral': 'Referral',
  'ref.title': 'Referral',
  'ref.sub': 'Invite friends and get a discount on Premium.',
  'ref.hero.title': 'Invite friends and pay less for Premium',
  'ref.hero.text': 'A friend signs up with your link and plays. You get 1 point for every finished match they play. {n} points give {pct}% off the subscription.',
  'ref.link': 'Your link',
  'ref.copy': 'Copy',
  'ref.copied': 'Link copied',
  'ref.copy_failed': 'Could not copy — select the link manually',
  'ref.share': 'Share',
  'ref.share_text': 'Play with me on CS Hub',
  'ref.code': 'Code',
  'ref.invited': 'Invited',
  'ref.invited_hint': 'signed up with your link',
  'ref.matches': 'Matches played',
  'ref.matches_hint': 'total by invited players',
  'ref.points': 'Your points',
  'ref.points_hint': '1 match = 1 point',
  'ref.progress': '{n} more points to the maximum {pct}% discount',
  'ref.progress_full': 'Maximum {pct}% discount unlocked',
  'ref.discount_now': 'You can get {pct}% off right now',
  'ref.use': 'Spend on Premium',
  'ref.how': 'How it works',
  'ref.step1.title': 'Send your link',
  'ref.step1.text': 'A friend signs up with your link.',
  'ref.step2.title': 'They play',
  'ref.step2.text': 'Every finished match they play earns you 1 point.',
  'ref.step3.title': 'Pay less',
  'ref.step3.text': '{n} points give {pct}% off Premium. Stacks with a promo code.',
  'ref.list': 'Invited players',
  'ref.list_matches': '{n} matches',
  'ref.empty.title': 'Nobody yet',
  'ref.empty.text': 'Send your link to a friend — they will show up here after signing up.',
  'ref.error': 'Could not load the referral page',
  'ref.retry': 'Retry',
  'ref.banner.title': 'Invite friends, get a Premium discount',
  'ref.banner.text': '1 point for every match a friend plays. {n} points give {pct}% off Premium.',
  'ref.banner.cta': 'Invite friends',
  'premium.points.title': 'Referral points',
  'premium.points.balance': 'You have {n} points',
  'premium.points.use': 'Spend {n} points — {pct}% off',
  'premium.points.none': 'Invite friends: {n} points give {pct}% off',
  'premium.points.invite': 'How to earn points',
  'premium.points.applied': '{n} points will be spent · {pct}% off',
  'premium.points.changed': 'Your points balance changed. Check the total and try again.',
  'premium.part_promo': 'Promo −{n}%',
  'premium.part_points': 'Points −{n}%',
  'premium.you_save': 'You save {amount}',
};
